import { render, staticRenderFns } from "./AppSettingsSreSeeProviders.vue?vue&type=template&id=bb1317b4&scoped=true&"
import script from "./AppSettingsSreSeeProviders.vue?vue&type=script&lang=js&"
export * from "./AppSettingsSreSeeProviders.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsSreSeeProviders.vue?vue&type=style&index=0&id=bb1317b4&prod&lang=scss&scoped=true&"
import style1 from "./AppSettingsSreSeeProviders.vue?vue&type=style&index=1&id=bb1317b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1317b4",
  null
  
)

export default component.exports